import React, { useState } from "react";
import './formOrganizationHq.css'
import { Input, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const FormOrganizationHq = ({ addOrganizationHq }) => {
    const [inputValue, setInputValue] = useState("");

    const handleAdd = () => {
        if (inputValue.trim()) {
            addOrganizationHq(inputValue);
            setInputValue(""); // Limpiar el input después de agregar
        }
    };

    return (
        <div style={{ display: "flex", gap: "8px", alignItems: "center", width: "100%" }}>
            <Input
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                placeholder="Añadir sede"
            />
            <Button type="primary" onClick={handleAdd} icon={<PlusOutlined />}>
                Agregar
            </Button>
        </div>
    );
};

export default FormOrganizationHq;
